export default __webpack_public_path__ + "static/media/padawansV.367c2f36.png";